import { defaultPrdInspectResultDto, PrdInspectResultDto } from "src/dtos/prdInspectResult/prdInspectResultDto";

// PRD3050_R01 전용 DTO (백엔드 PRD3050_R01Dto 매핑)
export interface PRD3050_R01Dto extends PrdInspectResultDto {
	productResultNo: string;
	compNm: string;
	jobTeamNm: string;
	itemNm: string;
	itemSpec: string;
	itemUnit: string;
	productQty: number;
	badRate: number;

	firstCase: string;
	firstCaseNm: string;
	firstCaseQty: number;
	firstCaseRate: number;

	secondCase: string;
	secondCaseNm: string;
	secondCaseQty: number;
	secondCaseRate: number;

	thirdCase: string;
	thirdCaseNm: string;
	thirdCaseQty: number;
	thirdCaseRate: number;

	otherCase: string;
	otherCaseNm: string;
	otherCaseQty: number;
	otherCaseRate: number;
	otherCaseCount: number;
}

export type GridRowData = PRD3050_R01Dto;

export const defaultProductResultData: PRD3050_R01Dto = {
	...defaultPrdInspectResultDto,
	productResultNo: '',
	compNm: '',
	jobTeamNm: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productQty: 0,
	badRate: 0,

	firstCase: '',
	firstCaseNm: '',
	firstCaseQty: 0,
	firstCaseRate: 0,

	secondCase: '',
	secondCaseNm: '',
	secondCaseQty: 0,
	secondCaseRate: 0,

	thirdCase: '',
	thirdCaseNm: '',
	thirdCaseQty: 0,
	thirdCaseRate: 0,

	otherCase: '',
	otherCaseNm: '',
	otherCaseQty: 0,
	otherCaseRate: 0,
	otherCaseCount: 0,
};
